import Client from './KomodoClient';
import { PAGE_ALL, pagerRows } from './Resource';

// komodo CustomBillController (api/custombill): bill-number rules of the customizable bill types.
// The row set is fixed (gy_bill.AllowCustom); saving upserts the merchant override (gy_custom_bill).
const enc = encodeURIComponent;

const queryPager = (query) =>
	Client.post('/api/custombill/query-pager', {
		...PAGE_ALL,
		...(query || {}),
	}).then(pagerRows);
const get = (billCode) => Client.get(`/api/custombill/${enc(billCode)}`);
const update = (billCode, dto) =>
	Client.put(`/api/custombill/${enc(billCode)}`, dto);

// BillNumberController: next number for a bill type without consuming the sequence.
const nextNumber = (billCode) =>
	Client.get(`/api/bil-number/next-number/${enc(billCode)}`);

export default { queryPager, get, update, nextNumber };
